module.exports = __webpack_public_path__ + "static/img/mo2.c69f096.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/mo2.png
// module id = WisG
// module chunks = 7